import { render, staticRenderFns } from "./PeTable.vue?vue&type=template&id=3fb4d8f6&"
import script from "./PeTable.vue?vue&type=script&lang=js&"
export * from "./PeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports